import { Trans, useTranslation } from 'react-i18next';
import { Button, Stack, Typography } from '@mui/material';
import NotificationsIcon from 'assets/notifications.svg?react';
import { DownState } from 'components/DownState';
import { openNativeAppSettings } from 'shared/utils';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(() => ({
  image: {
    width: '90vmin',
    height: 'auto',
    maxWidth: 345,
  },
}));

export const TurnOnNotificationsDownState = (): JSX.Element => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  return (
    <DownState
      states={[
        {
          renderImage: (imageProps) => (
            <NotificationsIcon {...imageProps} className={classes.image} />
          ),
          description: (
            <Stack spacing={2}>
              <Typography variant="h2" align="center">
                {t('notifications.turnOn.title')}
              </Typography>
              <Typography>
                <Trans i18nKey="notifications.turnOn.description">
                  Never miss important updates in your area by
                  <b>enabling notifications</b>. You will only receive
                  notifications from the counties you want.
                </Trans>
              </Typography>
            </Stack>
          ),
          Button: (
            <Button fullWidth size="large" onClick={openNativeAppSettings}>
              {t('notifications.turnOn.button')}
            </Button>
          ),
          containerProps: {
            sx: {
              flex: 1,
              justifyContent: 'space-between',
              p: 2,
              pb: 'max(env(safe-area-inset-bottom), 16px) !important',
            },
          },
        },
      ]}
    />
  );
};
